import lottie from 'lottie-web';
import { validateEmail } from './form-helpers';

import animation1Mobile from './animations/report/ILU01_mobile';
import animation1Desktop from './animations/report/ILU01_desktop';
import animation2Mobile from './animations/report/ILU02_mobile';
import animation2Desktop from './animations/report/ILU02_desktop';
import animation3Mobile from './animations/report/ILU03_mobile';
import animation3Desktop from './animations/report/ILU03_desktop';
import animation4Mobile from './animations/report/ILU04_mobile';
import animation4Desktop from './animations/report/ILU04_desktop';

import graph1 from './animations/report/wykres01';
import graph2 from './animations/report/wykres02';
import graph3 from './animations/report/wykres03';
import graph4 from './animations/report/wykres04';
import graph5 from './animations/report/wykres05';


const illustrationsMatrix = [
  {
    mobile: animation1Mobile,
    desktop: animation1Desktop,
  },
  {
    mobile: animation2Mobile,
    desktop: animation2Desktop,
  },
  {
    mobile: animation3Mobile,
    desktop: animation3Desktop,
  },
  {
    mobile: animation4Mobile,
    desktop: animation4Desktop,
  },
];

const graphs = [
  {
    animation: graph1,
    played: false
  },
  {
    animation: graph2,
    played: false
  },
  {
    animation: graph3,
    played: false
  },
  {
    animation: graph4,
    played: false
  },
  {
    animation: graph5,
    played: false
  },
];

function loadIllustration(key) {
  const container = document.getElementById('illustration-' + key);

  initLoopAnimation(container.querySelector('.mobile'), illustrationsMatrix[key].mobile);
  initLoopAnimation(container.querySelector('.desktop'), illustrationsMatrix[key].desktop);
}

function initLoopAnimation(element, animation) {
  lottie.loadAnimation({
    container: element,
    animationData: animation,
    autoplay: true,
    loop: true,
  });
}

function loadGraph(i) {
  graphs[i].lottie = lottie.loadAnimation({
    container: document.getElementById('graph-' + i),
    animationData: graphs[i].animation,
    autoplay: false,
  });
}

function isElementInViewPort(element) {
  const bounding = element.getBoundingClientRect();
  return (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

function validateForm() {
  let errors = 0;
  const isTermsAccepted = $('#check').prop('checked');
  const $inputs = getFormElement().find('input:not(#email_marketing_accepted)');
  const $termsElement = $('.contact-form-terms');
  const $errorsSummaryElement = $('.contact-form-require-error');

  for (let i = 0; i < $inputs.length; i++) {
    let $targetInput = $($inputs[i]);
    const elementId = $targetInput.attr('id');

    if ((elementId === 'check' && !isTermsAccepted) || (elementId !== 'check' && $targetInput.val() === '') ||
      (elementId === 'email' && !validateEmail($targetInput.val()))) {
      $targetInput.parent().addClass('has-error');
      $errorsSummaryElement.addClass('has-error');
      $('.contact-form-group.has-error') ? errors++ : '';
    } else {
      $targetInput.parent().removeClass('has-error');
    }
  }

  isTermsAccepted ? $termsElement.removeClass('has-error') : $termsElement.addClass('has-error');

  if (errors < 1) {
    getSubmitMessageContainer().removeClass('has-error');
    $errorsSummaryElement.removeClass('has-error');
  } else {
    getSuccessMessageElement().removeClass('has-error');
  }
  return (errors < 1);
}

function getFormElement() {
  return $('#downloadReport');
}

function getSubmitMessageContainer() {
  return $('.contact-form-submit');
}

function getSuccessMessageElement() {
  return $('.contact-form-success-message');
}

function sendData() {
  const form = getFormElement()
  const formData = form.serializeArray();
  form.addClass('disabled');

  formData.push({
    name: 'email_marketing_accepted',
    value: $('#email_marketing_accepted').is(':checked')
  });

  const csrftoken = document.querySelector('[name=csrfmiddlewaretoken]').value;

  $.ajax({
    url: FORM_ENDPOINT,
    data: JSON.stringify({'fields': formData}),
    type: 'POST',
    contentType: 'application/json',
    headers: {
      'X-CSRFToken': csrftoken
    },
    error: function (jqXHR, error, errorThrown) {
      form.removeClass('disabled');
      getSubmitMessageContainer().addClass('has-error');
    },
    success: function (data, textStatus, jqXHR) {
      form.removeClass('disabled');
      form[0].reset();
      getSuccessMessageElement().addClass('has-error');
    }
  });
}

$(document).ready(() => {
  for (let i = 0; i < illustrationsMatrix.length; i++) {
    loadIllustration(i);
  }

  for (let i = 0; i < graphs.length; i++) {
    loadGraph(i);
  }

  getScrollContainer().on('scroll', () => {
    for (let i = 0; i < graphs.length; i++) {
      if (isElementInViewPort(document.getElementById('graph-' + i))) {
        if (!graphs[i].played) {
          graphs[i].lottie.play();
          graphs[i].played = true;
        }
      }
    }
  });

  $('#downloadReport').on('submit', function (event) {
    event.preventDefault();
    const is_valid = validateForm();
    if (is_valid) {
      sendData();
    }
  });
});
